<label [closeOnOutSide]="isMenuOpen" (clickedOutside)="onClick()" class="text-center  text-white relative flex justify-end">
  <button #toggleButton (click)="toggleMenu($event)"
    class=" text-white outline-none font-semibold py-2 mr-2 focus:outline-none md:w-48 flex justify-center items-center rounded-md md:bg-primary">
    <div class="font-normal hidden md:block md:mr-2">Tiếp tục viết</div>
    <fa-icon class="text-gray-500 md:text-white" [icon]="faIcon"></fa-icon>
  </button>
  <div *ngIf="isMenuOpen" class="origin-top-right absolute right-0 top-8 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
    <div class="py-1 text-left">
      <ng-container *ngIf="contestNid === null;else noContestNid">
        <div *ngFor="let action of actions">
          <div (click)="handleBookAction(action.type)" class="block cursor-pointer px-4 py-2  text-gray-600 hover:bg-gray-100 hover:text-gray-900">
            <span class=" text-gray-500 mr-2">
              <fa-icon [icon]="action.icon"></fa-icon>
            </span>
            {{action.name}}
          </div>
        </div>
      </ng-container>
      <ng-template #noContestNid>
        <p class="text-center px-4 pt-2 font-bold">Truyện đã tham gia cuộc thi không thể thêm, sửa, xóa</p>
      </ng-template>
    </div>
    <div *ngIf="previewLink.length !== 0 " class="py-2 flex items-center border-t">
      <label class="block px-4 py-1  text-gray-700 flex-col items-start" role="menuitem">Liên kết bên ngoài
        <a target="_blank" [href]="previewLink.join('/')" class="block py-1 text-xs text-primary cursor-pointer" role="menuitem">
          {{ previewLink.join('/') }}
        </a>
      </label>
      <button [copy-clipboard]="previewLink.join('/')" (click)="isMenuOpen = false"
        class=" md:text-xs text-white bg-gray-400 inline-block text-right cursor-pointer rounded-sm border-primary focus:shadow-outline focus:outline-none px-2 py-1 hover:bg-primary"
        type="button">
        Copy
      </button>
    </div>
  </div>
</label>